<template>
	<section class="container page-content">
		<div class="row">
			<div class="col-xs-12 col-sm-8">
				<h1>Advanced search</h1>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-sm-8">
				<div class="form-group">
					<div class="form-group">
						<label class="form-label">Search term</label>
						<input
							v-model="searchTerm"
							type="text"
							class="form-control"
							placeholder="Search term"
						>
					</div>
					<template v-if="regions && regions.length > 0">
						<div class="form-group">
							<label class="form-label">Country/Region</label>
							<b-multi-select
								v-model="selectedRegions"
								:options="regions"
								class="multi-select"
								placeholder="Country/Region"
								filterable
								block
							/>
						</div>
					</template>
					<template v-if="status && status.length > 0">
						<div class="form-group">
							<label class="form-label">Status</label>
							<b-multi-select
								v-model="selectedStatus"
								:options="status"
								class="multi-select"
								placeholder="Select status"
								filterable
								block
							/>
						</div>
					</template>
					<template v-if="dates && dates.length > 0">
						<div class="form-group">
							<label class="form-label">Year</label>
							<b-multi-select
								v-model="selectedDates"
								:options="dates"
								class="multi-select"
								placeholder="Select year"
								filterable
								block
							/>
						</div>
					</template>
					<template v-if="tags && tags.length > 0">
						<div class="form-group">
							<label class="form-label">Type of issue</label>
							<b-multi-select
								v-model="selectedTags"
								:options="tags"
								class="multi-select"
								placeholder="Select issue"
								filterable
								block
							/>
						</div>
					</template>
				</div>
				<div class="row" style="margin-top:60px;">
					<div class="col-xs-12 col-sm-6">
						<b-btn type="default" style="margin-bottom:15px;" @click="reset">Reset</b-btn>
					</div>
					<div class="col-xs-12 col-sm-6">
						<b-btn type="primary" class="btn-lg btn-block" @click="search">Search</b-btn>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="less" scoped>
	.form-group {
		padding-bottom: 15px;
	}
</style>

<script>
import { map, flow, filter, orderBy } from 'lodash/fp';

export default {
	created() {
		this.getRegulationFilterOptions();
	},
	data() {
		return {
			searchTerm: null,
			regions: [],
			status: [],
			dates: [],
			tags: [],
			selectedRegions: [],
			selectedStatus: [],
			selectedDates: [],
			selectedTags: []
		};
	},
	computed: {
		selectedFilters() {
			return {
				regions: this.selectedRegions,
				status: this.selectedStatus,
				dates: this.selectedDates,
				tags: this.selectedTags
			};
		}
	},
	methods: {
		async getRegulationFilterOptions() {
			const { data: { data: options } } = await this.$axios.get('/resource/filter-options');

			const formattedRegions = flow(
				map(({ id, name }) => ({
					value: id,
					label: name
				})),
				orderBy('label', 'asc')
			)(options.filterOptions.regions);

			const formattedStatus = map(({ id, name }) => ({
				value: id, label: name
			}), options.filterOptions.status);

			const formattedDates = flow(
				filter(value => value !== 'Invalid date'),
				map(value => ({ value, label: value	}))
			)(options.filterOptions.dates);

			const formattedTags = map(({ id, name }) => ({
				value: id, label: name
			}), options.filterOptions.tags);

			this.$set(this, 'regions', formattedRegions);
			this.$set(this, 'status', formattedStatus);
			this.$set(this, 'dates', formattedDates);
			this.$set(this, 'tags', formattedTags);
		},
		reset() {
			this.searchTerm = null;
			this.selectedRegions = [];
			this.selectedStatus = [];
			this.selectedDates = [];
			this.selectedTags = [];
		},
		search() {
			this.$router.push({
				path: '/notifications',
				query: {
					searchTerm: this.searchTerm,
					selectedFilters: this.selectedFilters
				}
			});
		}
	}
};
</script>
